module.exports = __webpack_public_path__ + "img/index_reward_first.7df75d89.png";